import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function Analytics() {
  return <PlatformPage feature={platformFeatures['analytics']!} />
}
